<template>  
  <v-row justify="center" class="ma-0">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline font-weight-bold"><div v-html="sTitle"></div></v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5"><div v-html="sMsg"></div></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="isCancel" color="black darken-1" text @click="GoResult(false)" class="font-weight-bold">
            <v-icon class="mr-2">mdi-close</v-icon>취소
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="GoResult(true)" class="font-weight-bold">
            <v-icon class="mr-2">check_circle</v-icon>확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// 정보확인 다이올로그창 띄우기 (취소/저장 버튼존재) (항목지우기 등에 사용됨)
export default {
  data() {
    return {
      dialog: Boolean,
      sTitle: String,
      sMsg: String,
      isCancel : true,
    };
  },
  created() {
    this.dialog = false;
  },
  methods: {
    //다이올로그를 닫고 onMsgBox로 결과값 보냄
    GoResult: function(result) {
      this.dialog = false;      
      this.$emit("onMsgBox", result);
    },

    //결과값 표기시 줄바꿈문자가 혼용을 html로 바꾸고 다이얼로그를 띄움 (태그에서 v-html로 받음)
    RunMsgBoxShow: function(sTitle, sMsg) {       
      var s = sMsg.toString(); 
      this.sTitle = sTitle.replace(/(?:\r\n|\r|\n)/g, '<br />');
      this.sMsg = s.replace(/(?:\r\n|\r|\n)/g, '<br />');
      this.isCancel = true;
      this.dialog = true;
    },

    RunMsgBoxShow2: function(sTitle, sMsg) {       
      var s = sMsg.toString(); 
      this.sTitle = sTitle.replace(/(?:\r\n|\r|\n)/g, '<br />');
      this.sMsg = s.replace(/(?:\r\n|\r|\n)/g, '<br />');
      this.isCancel = false;
      this.dialog = true;
    },
  }
};
</script>
